<script setup lang='ts'>
import { ProjectAvatar } from '@forgd/ui-kit/blocks/avatars'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'

defineProps<{
  project: {
    image: string | null
    name: string | null
  }
}>()
</script>

<template>
  <div class="flex cursor-pointer items-center justify-between rounded-lg p-4 hover:bg-neutral-200">
    <div class="flex items-center gap-4">
      <ProjectAvatar :src="project.image" size="md" />
      <div class="flex flex-col">
        <span class="font-semibold">{{ project.name ?? 'Project name missing' }}</span>
      </div>
    </div>
    <ArrowRightIcon class="size-3 shrink-0 text-primal" aria-hidden="true" />
  </div>
</template>
